"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchForm = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const axios_1 = __importDefault(require("axios"));
const SearchForm = ({ updateWorks }) => {
    const [categories, setCategories] = (0, react_1.useState)([]);
    const [searchText, setSearchText] = (0, react_1.useState)('');
    const [searchOptions, setSearchOptions] = (0, react_1.useState)([]);
    const getCategories = () => {
        axios_1.default.get('api/categories').then((res) => {
            setCategories(res.data);
        });
    };
    const handleInputChange = (e) => {
        setSearchText(e.target.value);
    };
    let copyArray = [...searchOptions];
    const handleCheckboxChange = (e) => {
        const option = parseInt(e.target.value);
        if (e.target.checked) {
            copyArray.push(option);
        }
        else {
            copyArray = copyArray.filter((item) => {
                return item !== option;
            });
        }
        setSearchOptions(copyArray);
    };
    const searchFormOnClick = (event) => {
        event.preventDefault();
        if (!searchText.match(/\S/g) && searchOptions.length === 0) {
            alert('検索ワードを指定してください');
            return;
        }
        axios_1.default
            .get('/api/works/', {
            params: {
                searchText: searchText,
                searchOptions: searchOptions,
            },
        })
            .then((res) => {
            updateWorks(res.data);
        });
    };
    (0, react_1.useEffect)(() => {
        getCategories();
    }, []);
    const searchAllData = (event) => {
        event.preventDefault();
        axios_1.default.get('api/works').then((res) => {
            updateWorks(res.data);
        });
    };
    const toggleSearchOptions = (event) => {
        event.preventDefault();
        const el = event.target;
        const target = el.getAttribute('href');
        if (target) {
            const id = document.getElementById(target);
            id ? id.classList.toggle('active') : '';
        }
    };
    return ((0, jsx_runtime_1.jsxs)("form", { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "searchBox" }, { children: [(0, jsx_runtime_1.jsx)("input", { type: "text", className: "input", defaultValue: searchText, onChange: handleInputChange }), (0, jsx_runtime_1.jsx)("button", Object.assign({ type: "submit", onClick: searchFormOnClick }, { children: "Search" })), (0, jsx_runtime_1.jsx)("p", Object.assign({ className: "searchOption" }, { children: (0, jsx_runtime_1.jsx)("a", Object.assign({ onClick: searchAllData, href: "/" }, { children: "\u3059\u3079\u3066\u8868\u793A" })) })), (0, jsx_runtime_1.jsx)("p", Object.assign({ className: "searchOption" }, { children: (0, jsx_runtime_1.jsx)("a", Object.assign({ onClick: toggleSearchOptions, href: "searchOptions" }, { children: "options" })) }))] })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ id: "searchOptions", className: "searchOptions" }, { children: [(0, jsx_runtime_1.jsx)("p", { children: "\u30C1\u30A7\u30C3\u30AF\u3092\u3064\u3051\u3066\u3001Search\u30DC\u30BF\u30F3\u3092\u62BC\u3057\u3066\u304F\u3060\u3055\u3044" }), (0, jsx_runtime_1.jsx)("ul", { children: categories.map((category) => ((0, jsx_runtime_1.jsx)("li", { children: (0, jsx_runtime_1.jsxs)("label", { children: [(0, jsx_runtime_1.jsx)("input", { type: "checkbox", name: "searchOptions", value: category.id, onChange: handleCheckboxChange }), category.category] }) }, category.id))) })] }))] }));
};
exports.SearchForm = SearchForm;
